// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asset-preview.in-selection .thumbnail[data-v-8dcbcaaa]{height:132px}.asset-preview.in-selection .thumbnail img[data-v-8dcbcaaa]{max-height:130px}.asset-preview:hover .card-body .asset-info.stay[data-v-8dcbcaaa]{opacity:1}.preview-loading[data-v-8dcbcaaa]{position:absolute;left:0;top:0;right:0;bottom:0;margin:auto;z-index:2;height:20px}", ""]);
// Exports
module.exports = exports;
